import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Input, Button } from 'loyal-react'

import clients from 'redux/clients'

import Modal from 'react-awesome-modal'
import '@loyal_template/modal.css'

import Header from './Header'
const {
  cloudloyalty: { client }
} = clients

class FormVirtualVoucher extends React.Component {
  state = {
    email: {
      value:
        (this.props.cart.customer && this.props.cart.customer.email) ||
        this.props.participant.email.value,
      disabled: this.props.participant.email.disabled
    },
    isValid: true,
    isConfirmLoading: false,
    confirmVoucher: false
  }

  componentDidMount () {
    this.isValid()
  }

  handleInputValid = input => {
    if (input.error) return false

    return null
  }

  isValid = () => {
    const mailValidator = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/gim
    const { email } = this.state
    if (!mailValidator.test(email.value)) {
      this.setState({
        email: {
          value: email.value,
          disabled: email.disabled,
          error: 'Digite um e-mail válido'
        }
      })
      return false
    }
    return true
  }

  handleConfirm = (email) => {
    this.setState({ isConfirmLoading: true, confirmVoucher: false })
    client
      .post(`v1/carts/1/me/emailAddress?email=${email.value}`)
      .then(_ => {
        this.setState({ isConfirmLoading: false })
        this.props.handleStepChange(2)
      })
  }

  handleToggleModalConfirmation = () => {
    this.setState({ confirmVoucher: !this.state.confirmVoucher })
  }

  handleEmailChange = ({ target: { value } }) =>
    this.setState({ email: { ...this.state.email, value } })

  render () {
    const { step, handleStepChange } = this.props
    const { email, isValid, isConfirmLoading, confirmVoucher } = this.state

    if (step !== 0) {
      return (
        <div className='col-12' data-index='1'>
          <Header step={step} handleStepChange={handleStepChange} />
        </div>
      )
    }

    return (
      <Fragment>
        <div className='col-12' data-index='1'>
          <Header step={step} handleStepChange={handleStepChange} />
          <div className='row px-0 pb-2 border-bottom border-color-ui-3 bg-ui-5'>
            <div className='form-virtual-voucher col-12 px-2'>
              <div className='row mx-0'>
                <Input
                  id='input-email-profile-data'
                  label='E-mail'
                  className='col-6 col-md-6 mt-2'
                  required
                  name='email'
                  data-error={email.error}
                  valid={this.handleInputValid(email)}
                  onChange={this.handleEmailChange}
                  value={email.value}
                  disabled={email.disabled === 'true'}
                  onBlur={this.isValid}
                />
                <div className='col-6 col-md-6 mt-2'>
                  <Button
                    className='btn btn-sm btn-featured'
                    disabled={!email.value && !isValid}
                    onClick={this.handleToggleModalConfirmation}
                    text='Próximo'
                    loading={isConfirmLoading}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='modalConfirmationVoucher'>
          <Modal
            width='600'
            height='90%'
            effect='fadeInUp'
            visible={confirmVoucher}
          >
            <div className='modal-wrapper col-11 mx-auto bg-white radius px-2 py-3 border-bottom border-color-featured'>
              <div className='row'>
                <div className='col-12'>
                  <p className='txt-body-sm'>
                    O voucher será encaminhado para o e-mail: <strong>{email.value}</strong>.
                  </p>
                  <p className='txt-body-sm mt-1'>
                    Após o fechamento do pedido, não será possível alterar o e-mail para envio ou reenvio do voucher.
                  </p>
                </div>
                <div className='col-12 col-md-6  mt-2'>
                  <Button
                    className='btn btn-sm py-2'
                    disabled={!isValid}
                    onClick={this.handleToggleModalConfirmation}
                    text='Cancelar'
                    loading={isConfirmLoading}
                  />
                </div>
                <div className='col-12 col-md-6  mt-2'>
                  <Button
                    className='btn btn-sm btn-featured  py-2'
                    disabled={!isValid}
                    onClick={() => this.handleConfirm(email)}
                    text='Confirmar'
                    loading={isConfirmLoading}
                  />
                </div>
              </div>
            </div>
          </Modal>
        </div>

      </Fragment>
    )
  }
}

FormVirtualVoucher.propTypes = {
  participant: PropTypes.object.isRequired,
  cart: PropTypes.object.isRequired,
  step: PropTypes.number.isRequired,
  handleStepChange: PropTypes.func.isRequired
}

export default FormVirtualVoucher



// WEBPACK FOOTER //
// ./src/features/Checkout/FormVirtualVoucher/FormVirtualVoucher.js